module.exports = __webpack_public_path__ + "img/page7.528459ac.png";